/// <amd-module name="typeahead/features/AutocompleteParamModifier" />
/// <amd-dependency path="jquery" name="$"/>

/// <reference path="../../typings/typeahead/suggestionsProvider.d.ts"/>

import {IStripingConfiguration} from "typeahead/core/StripingConfiguration";
import {SuggestServiceParamModifier} from "typeahead/core/SuggestServiceParamModifier";

const autocompleteFeatureFlag: string = "google";

export class AutocompleteParamModifier extends SuggestServiceParamModifier {
    protected configuration: IStripingConfiguration[] = [
        {
            clients: ["Homepage", "HotelsLandingPage"],
            tabs: ["hotel"],
        },
        {
            clients: ["Hotels.Search"],
        },
    ];
    protected featureName: string = "GoogleAutocomplete";

    protected modify(params: ISuggestServiceQueryParams, context: IContext, options: any) {
        this.addFeatureFlag(params, autocompleteFeatureFlag);
    }
}
